<ion-content>
    <div class="modal-header-menu">
        <div class="modal-header-menu-backbutton" (click)="onGoBack()">
            <ion-icon name="arrow-back-outline"></ion-icon>
            {{ 'BACK' | translate }}
        </div>
    </div>
    <br><br>
    <div style="display: flex;align-items: center;">
        <img style="width: 80px;height: 80px;margin-left: 5px;" src="../../../assets/Totalum_Symbol.png">
        <div style="font-size: 20px;padding: 5%;padding-left: 0%;color: rgb(61, 61, 61);">
            <span *ngIf="!edit"> {{ 'CREATE_NEW' | translate }}</span>
            <span *ngIf="edit">{{ 'EDIT' | translate }}</span>
            {{ 'PROJECT' | translate }}
        </div>
    </div>

    <div style="padding:5%;margin-top: -40px;">

        <form [formGroup]="instanceForm">

            <ion-list>

                <div>
                    <div>
                        <ion-item lines="full" class="form-inputs-margin">
                            <ion-input type="text" [disabled]="edit"
                                placeholder="Introduce el identificador del proyecto (ej: mi-proyecto)"
                                [clearInput]="true" label="Nombre del proyecto (no se podrá cambiar)"
                                label-placement="stacked" formControlName="organizationId"
                                (ionInput)="toLowercase($event)"></ion-input>
                        </ion-item>
                        <div class="form-input-error" color="danger"
                            *ngIf="instanceForm.get('organizationId')?.invalid && instanceForm.get('organizationId')?.touched">
                            <ng-container *ngIf="!instanceForm.get('organizationId')?.valid">


                                The projectId must be between 4 and 35 characters, cannot start with a number, and the only special character allowed is "-".
                                <br>Examples: myproject, my-project, my-project-2, my-project-2-3
                            </ng-container>
                        </div>
                    </div>
                    <ion-item lines="full" class="form-inputs-margin">
                        <ion-label position="stacked">Plan</ion-label>
                        <ion-select formControlName="plan" placeholder="Selecciona un plan"
                            (ionChange)="calculePrice()">
                            <ion-select-option *ngFor="let plan of plansAvailable"
                                [value]="plan">{{plan}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                    <div class="form-input-error" color="danger"
                        *ngIf="instanceForm.get('plan')?.invalid && instanceForm.get('plan')?.touched">
                        <ng-container *ngIf="!instanceForm.get('plan')?.valid">Is mandatory to select a valid plan.</ng-container>
                    </div>
                </div>
                <div>
                    <ion-item lines="full" class="form-inputs-margin">
                        <ion-input type="text" placeholder="Introduce la descripción del proyecto" [clearInput]="true"
                            label="Descripción" label-placement="stacked" formControlName="description"></ion-input>
                    </ion-item>
                    <div class="form-input-error" color="danger"
                        *ngIf="instanceForm.get('description')?.invalid && instanceForm.get('description')?.touched">
                        <ng-container *ngIf="!instanceForm.get('description')?.valid">Is mandatory to enter a valid description of up to 200 characters.</ng-container>
                    </div>
                </div>
            </ion-list>
        </form>


        <div *ngIf="edit">
            <br>
            <div>Move files from this project to another</div>
            <ion-item lines="full" class="form-inputs-margin">
                <ion-label position="stacked">Select project to move files to</ion-label>
                <ion-select placeholder="Select a project" [(ngModel)]="organizationIdSelectedForMoveFiles">
                    <ion-select-option *ngFor="let instance of instancesAvailableForMoveFiles"
                        [value]="instance.organizationId">
                        {{ instance.organizationId }}
                    </ion-select-option>
                </ion-select>
            </ion-item>
            <br>
            <ion-button [disabled]="isLoading" (click)="moveFilesToAnotherInstance(organizationIdSelectedForMoveFiles)" *ngIf="organizationIdSelectedForMoveFiles">Mover archivos a
                {{organizationIdSelectedForMoveFiles}}</ion-button>

        </div>


        <br>
        <div *ngIf="priceToPay && priceToPay > 0 && (!edit || showUpdatePlan)"
            style="font-size: 18px;padding: 5px;border: solid 1px rgb(221, 221, 221);border-radius: 5px;background-color: rgb(247, 247, 247);">
            Al 
            <span *ngIf="!showUpdatePlan">create the </span>
            <span *ngIf="showUpdatePlan">Update the plan of the </span>
            project will cost you <b>{{priceToPay}}€ + VAT monthly</b> recurring to the card linked to your account.
        </div>

        <ion-spinner *ngIf="isLoading" name="lines"></ion-spinner>

        <ion-button *ngIf="!edit" [disabled]="isLoading" mode="ios" class="button-margin-top" (click)="onSubmit()">
            <ion-label>Create Project</ion-label>
        </ion-button>

        <ion-button *ngIf="edit" [disabled]="isLoading" mode="ios" class="button-margin-top" (click)="onEdit()">
            <ion-label>Edit Project</ion-label>
        </ion-button>

        <ion-button *ngIf="showUpdatePlan" [disabled]="isLoading" mode="ios" class="button-margin-top" (click)="updatePlan()">
            <ion-label>Update Plan</ion-label>
        </ion-button>

        <br><br><br>

        <div class="progress-bar" *ngIf="isLoading">
            <div class="progress"></div>
        </div>

    </div>

</ion-content>